import { render, staticRenderFns } from "./v1.vue?vue&type=template&id=1fe0ecda&scoped=true&"
import script from "./v1.vue?vue&type=script&lang=js&"
export * from "./v1.vue?vue&type=script&lang=js&"
import style0 from "./v1.vue?vue&type=style&index=0&id=1fe0ecda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe0ecda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe0ecda')) {
      api.createRecord('1fe0ecda', component.options)
    } else {
      api.reload('1fe0ecda', component.options)
    }
    module.hot.accept("./v1.vue?vue&type=template&id=1fe0ecda&scoped=true&", function () {
      api.rerender('1fe0ecda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/agent-dashboard/v1.vue"
export default component.exports